import DOMPurify from "dompurify";

// The generation skill promises headings, text, lists and simple tables; anything else
// (forms, inputs, styles, embeds) is treated as a defect rather than content.
const ALLOWED_TAGS = [
  "h1",
  "h2",
  "h3",
  "h4",
  "p",
  "br",
  "hr",
  "strong",
  "b",
  "em",
  "i",
  "u",
  "s",
  "code",
  "pre",
  "blockquote",
  "ul",
  "ol",
  "li",
  "table",
  "thead",
  "tbody",
  "tfoot",
  "tr",
  "th",
  "td",
  "caption",
  "a",
  "img",
  "span",
  "div",
  "sup",
  "sub"
];

const ALLOWED_ATTR = ["href", "title", "alt", "src", "colspan", "rowspan", "scope", "data-figure-key", "tabindex"];

// `tabindex` is allowed for the figure triggers only: any other element keeping it would become a
// tab stop the chapter never meant to have. Links leave the chapter in a new tab.
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.hasAttribute("tabindex") && !node.hasAttribute("data-figure-key")) node.removeAttribute("tabindex");
  if (node.tagName === "A" && node.hasAttribute("href")) {
    node.setAttribute("target", "_blank");
    node.setAttribute("rel", "noopener noreferrer");
  }
});

export function sanitizeChapterHtml(html: string): string {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
    FORBID_TAGS: ["style", "form", "input", "button", "iframe", "object", "embed", "script"]
  });
}
